import { Base } from "../../framework/base";
var RecordQualificationUserFurtherEducation = /** @class */ (function () {
    function RecordQualificationUserFurtherEducation(obj) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.valid = obj && obj.valid || false;
        this.validityEndDate = obj && obj.validityEndDate || null;
    }
    RecordQualificationUserFurtherEducation.Create = function (id, code, valid, validityEndDate) {
        var result = new RecordQualificationUserFurtherEducation();
        result.id = id;
        result.code = code;
        result.valid = valid;
        result.validityEndDate = validityEndDate;
        return result;
    };
    RecordQualificationUserFurtherEducation.sortRecordQualificationUserFurtherEducation = function (items, column, asc) {
        if (!items && items.length < 2)
            return items;
        if (column === "validity") {
            return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare((a.id ? 10 : 0) + (a.valid ? 1 : 0), (b.id ? 10 : 0) + (b.valid ? 1 : 0))); });
        }
        else if (column === "validityEndDate") {
            return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.validityEndDate, b.validityEndDate)); });
        }
        else {
            return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.code, b.code)); });
        }
    };
    return RecordQualificationUserFurtherEducation;
}());
export { RecordQualificationUserFurtherEducation };
